import React, { useEffect } from "react";
import { Flex } from "antd";
import ModalComponent from "@/components/modal";
import ButtonComponent from "@/components/button/Button";
import { useNavigate } from "react-router-dom";
import { setCurrentForm, setModalOpen } from "@/reducers/commonSlice";
import { useDispatch } from "react-redux";

const ApplyForGuide = ({
  isOpen,
  message = "Successfully",
  subMessage = "",
  btnLabel = "Go to Dashboard",
  onSubmit = () => {},
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(setCurrentForm("guidePlatform"));
    dispatch(setModalOpen(true));
  };

  // prevent scroll on body when drawer is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);
  return (
    <ModalComponent isOpen={isOpen} width={400}>
      <Flex vertical gap="1rem" align="center">
        <div className="icon-wrapper">
          <img src="/assets/images/applyForGuide.svg" alt="" />
        </div>
        <div className="body-b1 text-center">
          {"Ensure you have the following data before applying."}
        </div>

        <div className="body-b4 text-center">
          <div className="data-list">
            <div className="data-item">- University Email</div>
            <div className="data-item">- Student ID Card/Visa</div>
            <div className="data-item">- Country</div>
            <div className="data-item">- University Name</div>
            <div className="data-item">- Level</div>
            <div className="data-item">- Course</div>
            <div className="data-item">- Year of completion</div>
            <div className="data-item">- CV/Resume PDF</div>
          </div>
        </div>
        <Flex vertical gap="1rem" align="center">
          <div>
            <ButtonComponent label={"Apply Now"} type="primary" onClick={handleClick} />
          </div>
        </Flex>
      </Flex>
      <style jsx>{`
        .data-list {
          display: grid;
          grid-template-columns: repeat(2, 1fr); /* 2 columns */
          gap: 10px; /* Space between items */
        }
        .data-item {
          color: #333;
        }
      `}</style>
    </ModalComponent>
  );
};

export default ApplyForGuide;
